import NavTabs from '../NavTabs'

const DATA_EDIT_TABS = [
  { label: 'Agro Data Edit', to: 'agro' },
  { label: 'Picking Data Edit', to: 'picking' },
  { label: 'Packing Data Edit', to: 'packing' },
  { label: 'Timing Data Edit', to: 'timing' }
]

const DataEditNav = () => <NavTabs tabs={DATA_EDIT_TABS} />

export default DataEditNav
